<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import Modal from '../modal/modal.svelte';

    export let title = '';
    export let description = '';
    export let icon;
    export let buttonText = 'OK';
    export let type = '';

    const dispatch = createEventDispatcher();
</script>

<Modal isOpen={true} maxWidth={450} {type}>
    <div class="content phone:!gap-8">
        {#if icon}
            <img src={icon} alt="icon" class="icon" />
        {/if}
        <h1 class="title phone:!text-4xl">{title}</h1>
        {#if description}
            <p class="description">{description}</p>
        {/if}
        <button class="phone:!w-auto phone:!px-12" on:click={() => dispatch('close')}>{buttonText}</button>
    </div>
</Modal>

<style lang="scss">
    .content {
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        place-items: center;
        flex-wrap: nowrap;
        flex-shrink: 0;
        flex-grow: 0;
        min-height: 180px;
        padding: 32px 24px;
        gap: 24px;
        text-align: center;
        background: #292929;
        border-radius: 16px;

        .title {
            font-family: 'Roboto Condensed', serif;
            font-weight: 600;
            font-size: 24px;
            line-height: 100%;
            text-align: center;
        }

        .description {
            font-family: 'Roboto Condensed', serif;
            color: #cccccc;
            font-weight: 300;
            font-size: 14px;
            line-height: 16px;
        }

        .icon {
            width: 80px;
            height: 80px;
        }

        button {
            all: unset;
            display: flex;
            flex-direction: column;
            justify-content: center;
            place-items: center;
            flex-wrap: nowrap;
            flex-shrink: 0;
            flex-grow: 0;
            width: auto;
            height: 40px;
            cursor: pointer;
            max-width: 290px;
            background: linear-gradient(90deg, #01378c 0%, #1f77ff 100%);
            box-shadow: 0 6px 6px rgba(0, 10, 26, 0.5);
            border-radius: 65.3182px;
            font-family: 'Roboto Condensed', serif;
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 100%;
            width: 100%;
            padding: 0;

            &:active {
                transform: scale(0.95);
            }
        }
    }
</style>
